<template>
  <el-card>
    <div slot="header" class="clearfix">
      <h2 style="display: inline-block"></h2>
    </div>

    <div class="row">
      <div class="col-md-12">
        <el-form
          class="template-form"
          :model="template"
          :rules="rules"
          label-width="190px"
          label-position="left"
          ref="emailForm"
        >
          <el-form-item label="Name" prop="name">
            <el-input v-model="template.name" />
          </el-form-item>

          <el-form-item label="Template Type" prop="type">
            <el-select class="full-width" v-model="template.type">
              <el-option
                v-for="item in templateTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="Subject" prop="subject">
            <el-input v-model="template.subject" />
          </el-form-item>

          <el-form-item label="Body" prop="content">
            <ck-editor v-model="template.content" @ready="onEditorReady" :config="editorConfig" />
            <div v-if="template.type">
              <el-tag
                size="small"
                style="margin: 10px 5px"
                v-for="temp in templateVars.global"
                :key="temp"
                >{{ `\{\{${temp}\}\}` }}
              </el-tag>
              <el-tag
                size="small"
                style="margin: 10px 5px"
                v-for="temp in templateVars[template.type.toLowerCase()]"
                :key="temp"
                >{{ `\{\{${temp}\}\}` }}
              </el-tag>
            </div>
          </el-form-item>
          <hr />
          <div class="">
            <div class="pull-right">
              <el-button type="default" @click="handleCancel">Cancel</el-button>
              <el-button type="primary" @click="handleFormSave" :disabled="loading">
                <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                Save
              </el-button>
            </div>
            <br />
          </div>
        </el-form>
      </div>
    </div>
  </el-card>
</template>

<script>
import moment from 'moment';
import { component as ckEditor } from 'ckeditor4-vue';

export default {
  name: 'TemplateEditor',
  components: {
    ckEditor,
  },
  props: {
    template: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    moment,
    rules: {
      name: [{ required: true, message: 'Please give this email a nice name' }],
      type: [{ required: true, message: 'Please select a template type' }],
      subject: [{ required: true, message: 'Please input an email subject' }],
      content: [{ required: true, message: 'Please give this email a nice name' }],
    },
    templateTypes: [
      { label: 'Programming Dashboard Summary', value: 'PROGRAMMING' },
      { label: 'Campaign Lifetime Summary', value: 'CAMPAIGN' },
      { label: 'Survey Lifetime Summary', value: 'SURVEY' },
    ],
    templateVars: {
      global: ['station_name', 'day', 'month', 'year'],
      campaign: ['campaign_name', 'campaign_type', 'campaign_start_date', 'campaign_end_date'],
      survey: ['survey_name', 'survey_description', 'survey_start_date', 'survey_end_date'],
    },
    editorConfig: {
      extraPlugins: 'preview',
      allowedContent: true,
    },
  }),

  methods: {
    handleCancel() {
      this.$emit('onCancel');
    },

    handleBack() {
      this.$router({ path: '/admin/templates' });
    },

    handleFormSave() {
      this.template.id = parseInt(this.template.id, 10);
      this.$emit('onSave', this.template);
    },

    onEditorReady(editor) {
      this.editor = editor;
    },
  },
};
</script>

<style scoped>
.template-form {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// TemplateEditor.vue?53e62f24